






































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import gtSearch from "@/components/pages/Product/search.vue";
import selectFamilyDialog from "@/components/pages/ProductCreate/selectFamily.vue";
import exportProducts from "@/components/pages/Product/exportProducts.vue";

const product = namespace("product");
const Root = namespace("root");
const defaultImageLink = require("@/assets/image/default_product_image_v2.png");
@Component({
  components: { gtSearch, selectFamilyDialog, exportProducts },
  filters: {
    pic0(value: string) {
      if (value) {
        return value.split(",")[0] || "@/assets/image/default.png";
      }
    }
  }
})
export default class HelloWorld extends Vue {
  @product.Getter productList: any;
  @product.Getter total: number;
  @product.State PageInput: any;
  @product.State loading: boolean;
  @product.State params: any;
  @product.Action getPorducts: any;
  @product.Action deleteProduct: any;
  @product.Action UpdateProductStatus: any;
  @product.Action updateProductStatusBatch: any;
  @product.Mutation setPageInput: any;
  @Root.State permission;
  get readonly() {
    return {
      create: !this.permission.PIM_PRODUCT_CREATE_BUTTON,
      edit: !this.permission.PIM_PRODUCT_EDIT_BUTTON,
      delete: !this.permission.PIM_PRODUCT_DELETE_BUTTON,
      onBatch: !this.permission.PIM_PRODUCT_ON_BATCH_BUTTON,
      downBatch: !this.permission.PIM_PRODUCT_DOWN_BATCH_BUTTON,
      down: !this.permission.PIM_PRODUCT_DOWN_BUTTON,
      on: !this.permission.PIM_PRODUCT_ON_BUTTON
    };
  }

  get isHidden() {
    return false;
  }

  getRowKeys(row) {
    return row.productCode;
  }
  get operateList() {
    return [
      {
        name: "deactivate",
        command: "handleChangeStatus",
        text: this.$t("Product.deactivate"),
        disabled: this.readonly.down
      },
      {
        name: "activate",
        command: "handleChangeStatus",
        text: this.$t("Product.activate"),
        disabled: this.readonly.on
      },
      {
        name: "delete",
        command: "handleDelete",
        text: this.$t("Basic.Delete"),
        disabled: this.readonly.delete
      }
    ];
  }
  handleOperateClick(command, row) {
    this[command] && this[command](row);
  }
  operateIsShow(node, li) {
    if (li.name === "activate") {
      return node.status !== 1;
    } else if (li.name === "deactivate") {
      return node.status === 1;
    } else {
      return true;
    }
  }
  async mounted() {
    this.params.productName = "";
    this.setPageInput({
      ...this.PageInput,
      pageNum: 1
    });
    await this.getPorducts();
  }

  handleDelete(data): void {
    if (this.readonly.delete) {
      return;
    }
    let { productCode, orgCode } = data;
    const message: any = this.$t("Basic.confirm_delete");
    this["$confirm"](message, "").then(async () => {
      await this.deleteProduct({
        codeList: [productCode],
        orgCode
      });
      this.handleDeleteLastone();
    });
  }

  /**
   * @desc 处理图片展示
   * @return { string }
   */
  handleMobileMediaLink(listData) {
    const { mobileMediaLink, mediaLink } = listData;
    return mobileMediaLink
      ? mobileMediaLink.split(",")[0]
      : mediaLink
      ? mediaLink.split(",")[0]
      : defaultImageLink;
  }

  async handleDeleteLastone() {
    if (this.productList.length == 1) {
      this.setPageInput({
        ...this.PageInput,
        pageNum: this.PageInput.pageNum - 1
      });
    }
    await this.getPorducts();
    this.clearSelection();
  }

  async handleChangeStatus(row): Promise<void> {
    let { productCode, status } = row;
    await this.UpdateProductStatus({
      productCode: productCode,
      status: Number(!status)
    });
    let info: any = this.$t("Basic.success");
    this.$message({
      type: "success",
      message: info
    });
    await this.getPorducts();
    this.clearSelection();
  }

  async commonPageChange(val = {}) {
    this.setPageInput({
      ...this.PageInput,
      ...val
    });
    await this.getPorducts();
  }

  async handlePageChange(val) {
    this.commonPageChange({ pageNum: val });
  }

  async handleSizeChange(val) {
    this.commonPageChange({ pageSize: val });
  }
  searchProduct(data) {
    // console.log(data);
  }
  // 导出筛选商品
  exportProduct() {
    (this as any).$refs.exportProducts.visible = true;
  }
  createProduct() {
    if (this.readonly.create) {
      return;
    }
    (this.$refs.selectFamilyDialog as any).visible = true;
  }
  batchProducts = [];
  handleSelectionProduct(list) {
    this.batchProducts = list;
  }
  toggleStatusBatch(oldStatus, status, batchNotice, noreat) {
    let batchEmpty: any = this.$t("Product.batch_empty");
    let confirm: any = this.$t("Basic.Confirm");
    let cancel: any = this.$t("Basic.Cancel");
    if (!this.batchProducts.length) {
      this.$message({
        message: batchEmpty,
        type: "warning"
      });
      return;
    }
    let length = this.batchProducts.filter(_ => _.status === oldStatus).length;
    if (length === 0) {
      this.$message({
        message: noreat,
        type: "error"
      });
      return;
    }
    this.$confirm(batchNotice, {
      confirmButtonText: confirm,
      cancelButtonText: cancel,
      type: "warning"
    })
      .then(async () => {
        let params = this.batchProducts.map(_ => {
          return { productCode: _.productCode, status: status };
        });
        await this.updateProductStatusBatch(params);
        let info: any = this.$t("Basic.success");
        this.$message({
          type: "success",
          message: info
        });
        await this.getPorducts();
        if (this.productList.length === 0) {
          await this.handlePageChange(1);
        }
        this.clearSelection();
      })
      .catch(error => {
        console.log(error);
      });
  }
  // 批量上架
  handleBatchActive() {
    if (this.readonly.onBatch) {
      return;
    }
    let num = this.batchProducts.length;
    let batchNotice: any =
      (this as any).$t("Product.batch_num", { num }) +
      this.$t("Product.batch_active_notice");
    let noRepeat: any = this.$t("Product.no_active");
    this.toggleStatusBatch(0, 1, batchNotice, noRepeat);
  }
  // 批量下架
  handleBatchDeactive() {
    if (this.readonly.downBatch) {
      return;
    }
    let num = this.batchProducts.length;
    let batchNotice: any =
      (this as any).$t("Product.batch_num", { num }) +
      this.$t("Product.batch_deactive_notice");
    let noRepeat: any = this.$t("Product.no_deactive");
    this.toggleStatusBatch(1, 0, batchNotice, noRepeat);
  }
  clearSelection() {
    (this.$refs.productTable as any).clearSelection();
    this.batchProducts = [];
  }
  handleEdit(row) {
    if (this.readonly.edit) {
      return;
    }
    let routeUrl = this.$router.resolve({
      name: "ProductEdit",
      query: { productCode: row.productCode }
    });
    window.open(routeUrl.href, "_blank");
  }
  handleView(row) {
    let routeUrl = this.$router.resolve({
      name: "ProductEdit",
      query: { productCode: row.productCode, isViewMode: "true" }
    });
    window.open(routeUrl.href, "_blank");
  }

  getFirstProp(list, prop) {
    return (list && list[0] && list[0][prop]) || 0.0;
  }
}
